// extracted by mini-css-extract-plugin
export default {"messageValueContainer":"styles_messageValueContainer__-2ObR","messageValue":"styles_messageValue__wPHpb"};